import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProviderDataValidators as Validators } from '@app/modules/data-valiidator';
import { SpinnerService } from '@app/@shared/spinner/spinner.service';
import { UserService } from '@app/services/user.service';
import { WellBeingService } from '@app/wellBeing/wellBeing.service';
import { QuestionType } from '@app/interface/survey';
import { finalize } from 'rxjs/operators';
import { NotificationService } from './notification.service';
import { NotificationTypeEnumes, NotificationSendTypeEnumes } from '@shared/enums/notificationType';

@Component({
  selector: 'app-add-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  @Input() title_tag: string;
  @Input() formType: string;
  notificationForm: FormGroup;
  isFormSubmitted = false;
  isLoading = false;
  uploadedFiles: any[] = [];
  preview: string;
  ntypeFields: QuestionType[] = [
    { value: 'activity', viewValue: NotificationTypeEnumes.ACTIVITY },
    { value: 'survey', viewValue: NotificationTypeEnumes.SURVEYS },
    { value: 'studies', viewValue: NotificationTypeEnumes.STUDIES },
  ];
  selectedNotificationTopicType: string;
  userDropDownList: any = [];
  selectedItems: any = [];
  dropdownSettings = {};
  selectedNotificationType = NotificationSendTypeEnumes.USER;
  error: any;

  constructor(
    public activeModal: NgbActiveModal,
    public notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    public userService: UserService,
    public wellBeingService: WellBeingService
  ) {}

  ngOnInit() {
    this.getAddnotificationForm();
    this.getFcmTokens();
  }

  public getFcmTokens(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'fcmToken',
      textField: 'userEmail',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.userService.getFcmTokens().subscribe((data: any) => {
      this.userDropDownList = data;
    });
  }

  public selectNotificationTopic(e: any): void {
    this.selectedNotificationTopicType = e.value['viewValue'];
  }

  onNotificationUploadIcon(event: any): void {
    const reader = new FileReader();
    const [file] = event.target.files;
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.preview = reader.result as string;
      this.notificationForm.patchValue({
        icon: reader.result,
      });
    };
  }

  get f() {
    return this.notificationForm.controls;
  }

  save() {
    this.isFormSubmitted = true;
    const notificationFormData = this.notificationForm.value;
    if (this.notificationForm.valid) {
      notificationFormData['topic'] !== null &&
        (notificationFormData['topic'] = notificationFormData['topic']['value']);
      let userTokens = notificationFormData.usersTokens?.map(function (item: any) {
        return item.fcmToken;
      });
      const notificationPayload = {
        notification: {
          title: notificationFormData.title,
          body: notificationFormData.body,
        },
        android: {
          ttl: '86400s',
          notification: {
            click_action: 'OPEN_ACTIVITY_1',
          },
        },
        apns: {
          headers: {
            'apns-priority': '5',
          },
          payload: {
            aps: {
              category: 'NEW_MESSAGE_CATEGORY',
            },
          },
        },
        webpush: {
          headers: {
            TTL: '86400',
          },
        },
        to: notificationFormData['topic'] === null ? userTokens.toString() : '/topics/' + notificationFormData['topic'],
      };
      this.submitNotification(notificationPayload);
    } else {
      return;
    }
  }

  submitNotification(notificationData: any): void {
    this.isLoading = true;
    this.spinnerService.show();
    this.notificationService
      .sendNotificationData(notificationData)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (data: any = []) => {
          this.isLoading = false;
          this.isFormSubmitted = false;
          this.activeModal.close(true);
          this.spinnerService.hide();
        },
        (error: any) => {
          this.error = error;
          this.isLoading = false;
          this.isFormSubmitted = false;
          this.spinnerService.hide();
        }
      );
  }

  changeNotificationType(selectedNotificationEvent: any): void {
    switch (selectedNotificationEvent.target.value) {
      case NotificationSendTypeEnumes.USER: {
        this.getFcmTokens();
        this.selectedNotificationType = NotificationSendTypeEnumes.USER;
        break;
      }
      case NotificationSendTypeEnumes.TOPIC: {
        this.userDropDownList = [];
        this.selectedNotificationType = NotificationSendTypeEnumes.TOPIC;
        break;
      }
    }
  }

  getAddnotificationForm() {
    this.notificationForm = this.formBuilder.group({
      title: ['', [Validators.required()]],
      body: [null, [Validators.required()]],
      notificationType: [NotificationSendTypeEnumes.USER],
      usersTokens: [],
      topic: [null, []],
    });
  }
}
